import { InventoryOutlinedIcon, NoRowsOverlay } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

import { AddQBSButton } from '../../components';
import { ADD_QBANK_REQUIRED_PERMISSIONS } from '../../constants';

export function QConfigStructureNoRowsOverlay() {
  const hasPermissionForAddingQBank = useHasPermission(ADD_QBANK_REQUIRED_PERMISSIONS);

  return (
    <NoRowsOverlay
      title='เริ่มสร้างโครงสร้างข้อสอบ'
      description={`เลือกคลังข้อสอบและหมวดที่ต้องการเพื่อกำหนดโครงสร้างข้อสอบ\nโดยสามารถเลือกได้หลายคลังข้อสอบตามที่ต้องการ`}
      icon={InventoryOutlinedIcon}
      action={hasPermissionForAddingQBank ? <AddQBSButton size='large' /> : undefined}
    />
  );
}
